import { useEffect } from "react";
import { HallsForm } from "components";
import ReactGA from "react-ga4";
import { useSearchParams } from "react-router-dom";
import { Typography } from "theme";

import { Box } from "@mui/material";

const HallSelection = () => {
  const [searchParams] = useSearchParams();

  useEffect(() => {
    ReactGA.send({ hitType: "pageview", page: window.location.href, title: "HALL_SELECTION_PAGE" });
  }, []);
  return (
    <Box>
      <Typography variant="h1" color="primary">
        Зали
      </Typography>
      <HallsForm
        defaultValues={{
          halls: searchParams.get("h") || "",
        }}
      />
    </Box>
  );
};

export default HallSelection;
